import RemoveCheckedTodos from './RemoveCheckedTodos'

export default RemoveCheckedTodos